import { Member } from '@/types/Member.type'
import { GetMembershipDetailsResponse, GetSubscriptionsResponse } from '@/types/response/GetMembershipDetailsResponse'
import { MemberLead } from '@/types/MemberLead.type'
import { Socket } from 'socket.io-client'
import { UserTokenDecoded } from '@/types/UserTokenDecoded.type'
import { jwtTokenName } from '@/utils/auth'
import { ClaimableNFT } from '@/types/nft/ClaimableNFT.type'

export type State = {
    token: string | null
    decodedToken: UserTokenDecoded | null // Deprecated: Use the getter `jwtTokenDecoded` instead
    me: Member | MemberLead | null
    meCompleted: boolean
    membership: GetMembershipDetailsResponse | null
    subscriptions: GetSubscriptionsResponse | null
    networkingToken: string | null
    socket: Socket | null
    socketId: string | null
    walletAddress: string
    nftList: ClaimableNFT[]
    loading: {
        membership: boolean
        subscriptions: boolean
    }
}

const state = (): State => {
    return {
        token: window.sessionStorage.getItem(jwtTokenName) || null,
        decodedToken: null,
        me: null,
        meCompleted: false,
        networkingToken: window.sessionStorage.getItem('networkingToken') || null,
        membership: null,
        subscriptions: null,
        socket: null,
        socketId: null,
        walletAddress: '',
        nftList: [],
        loading: {
            membership: false,
            subscriptions: false,
        },
    }
}

export default state
